import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MessageContext } from "../../../../common/message";
import { cleanJoin } from "../../../../utils/stringUtil";
import "./RemoveDocument.scss";
import { anyUploadInProgress } from "../../../requests/submission/requestSubmissionValidator";

function RemoveDocument({ index, documents, dispatchUpdateAction }) {
  const message = useContext(MessageContext);
  const { t } = useTranslation();

  const [enabled, setEnabled] = useState(!anyUploadInProgress(documents));

  useEffect(() => {
    setEnabled(!anyUploadInProgress(documents));
  }, [documents]);

  return (
    <FontAwesomeIcon
      icon={faTimes}
      className={cleanJoin(
        "is-size-5",
        "remove-document",
        enabled ? "is-clickable" : "",
        enabled ? "has-text-grey-dark" : "has-text-grey",
        "has-background-white"
      )}
      onClick={() => {
        if (enabled) {
          message.toggle({
            title: t("requests.submission.upload.deleteAttachmentMessageTitle"),
            content: t("requests.submission.upload.deleteAttachmentMessage"),
            onNo: () => message.toggle({}),
            onYes: () => {
              documents.splice(index, 1);
              dispatchUpdateAction();
              message.toggle({});
            },
          });
        }
      }}
    />
  );
}

export default RemoveDocument;
